import Repository from "./Repository";

const resource = "/login";

export default {
  login(payload) {
    return Repository.post(resource, payload);
  },

  /**
   * Request password reset
   *
   * @param email Email address
   */
  requestPasswordReset(email) {
    return Repository.post("/password/email", {
      email,
      platform: "DESKTOP"
    });
  },

  /**
   * Password reset
   *
   * @param email Email address
   * @param password New password
   * @param token Token
   */
  passwordReset({ email, password, token }) {
    return Repository.post("/password/reset", {
      email,
      password,
      token
    });
  }
};
